<!-- 一图读懂 -->
<template>
	<div v-if="quarterInfo.longImage" class="data-wrapper">
		<p class="wrapper-title">{{ title }}</p>
		<div class="easy-image-block" @click="previewCover">
			<div class="easy-image-title">{{ quarterInfo.announcementTitle }}</div>
			<div
				:style="{
					backgroundImage: `url(${quarterInfo.longImage})`
				}"
				class="easy-image-cover"
			></div>
		</div>
	</div>
</template>

<script setup>
import { useModuleNavigation } from '@rebuild/hooks/useModuleNavigation';

const props = defineProps({
	quarterInfo: {
		type: Object,
		default: () => ({})
	},
	title: {
		type: String,
		default: ''
	}
});

const { viewModule } = useModuleNavigation();
const previewCover = () => {
	viewModule('quarterly_performance_image_preview', props.quarterInfo);
};
</script>

<style lang="less" scoped>
.data-wrapper {
	margin-bottom: 0.14rem;
	padding: 0.14rem 0.12rem;
	border-radius: 0.06rem;
	background: #fff;
	overflow: hidden;

	.wrapper-title {
		color: #333;
		font-family: 'PingFang SC';
		font-size: 0.16rem;
		font-style: normal;
		font-weight: 500;
		line-height: 0.22rem;
	}
}

.easy-image-block {
	margin-top: 0.14rem;
	display: flex;

	.easy-image-title {
		flex: 1;
		width: 0;
		color: #333;
		font-family: 'PingFang SC';
		font-size: 0.15rem;
		font-style: normal;
		font-weight: 500;
		line-height: 140%;
	}
	.easy-image-cover {
		margin-left: 0.08rem;
		flex: none;
		width: 0.82rem;
		height: 0.6rem;
		background-position: 0 0;
		background-size: cover;
	}
}
</style>
